import React from 'react'

const ViewFeeDetails = () => {
  return (
    <div>
      
    </div>
  )
}

export default ViewFeeDetails
